import React from "react";
import { Routes, Route } from "react-router-dom";

import ListingAssociations from "./AppliAdmin/ListingClients/ListingAssociations";
import DashboardAdmin from "./AppliAdmin/DashboardAdmin/DashboardAdmin";
import Notifications from "./AppliAdmin/Notifications/Notifications";
import ContactForm from "./AppliAdmin/ContactForm/ContactForm";
import ListingProducts from "./AppliAdmin/ListingProducts/ListingProducts";
import RegisterAssociationForm from "./AppliUser/RegisterAssociationForm";
import MonAssociationPage from "./AppliUser/MonAssociationPage/MonAssociationPage";
import Profil from "./AppliAdmin/Profil/Profil";
import PricingPageForProspects from "./AppliUser/PricingPageForProspects/PricingPageForProspects";
import SubscriptionsPage from "./AppliAdmin/SubscriptionsPage/SubscriptionsPage";
import UpdatesPage from "./AppliAdmin/UpdatesPage/UpdatesPage";
import Tutoriel from "./AppliUser/Tutoriel/Tutoriel";
import DesinscriptionsPage from "./AppliAdmin/DesinscriptionsPage/DesinscriptionsPage";
import ParrainagePage from "./AppliAdmin/Parrainage/ParrainagePage";
import ProspectsPage from "./AppliAdmin/ProspectsPage/ProspectsPage";
import ProductsAppPage from "../ProductsAppPage/ProductsAppPage";
import ListingTasks from "./AppliAdmin/ListingTasks/ListingTasks";
import ListingFaq from "./AppliAdmin/ListingFaq/ListingFaq";
import ProgressPhasesList from "./AppliAdmin/DashboardAdmin/ProgressPhasesList";
import CartoClients from "./AppliAdmin/ListingClients/CartoClients";
import ProspectionPage from "./AppliAdmin/ProspectionPage/ProspectionPage";
import FinanceCommitmentsPage from "./AppliAdmin/Business/Finance/FinanceCommitmentsPage";
import SiteActivityPage from "./AppliAdmin/SiteActivity/SiteActivityPage";
import ListingTaches from "./AppliAdmin/Taches/ListingTaches";
import SuiviClients from "./AppliAdmin/SuiviClients/SuiviClients";

import useScrollToTop from "../../hooks/useScrollToTop";
import useDashboardAlerts from "../../hooks/useDashboardAlerts";
import DashboardTopbar from "./DashboardTopbar";
import VisitorCenterPage from "./AppliAdmin/VisitorCenter/VisitorCenterPage";
import TutorialsAdminPage from "./../tutorials/admin/pages/TutorialsAdminPage";
import TutorialEditorPage from "./../tutorials/admin/pages/TutorialEditorPage";

const MainContent = ({ role_id, isMenuOpen }) => {
  useScrollToTop();

  const asideWidth = isMenuOpen ? 290 : 92;

  const dashboardAlerts = useDashboardAlerts({
    enabled: role_id === 1,
  });

  return (
    <main
      className="h-screen overflow-hidden bg-[#EEF7FC] transition-all duration-300"
      style={{
        marginLeft: `${asideWidth}px`,
        width: `calc(100% - ${asideWidth}px)`,
      }}
    >
      <div className="flex h-full min-w-0 flex-col">
        <DashboardTopbar
          role_id={role_id}
          alerts={dashboardAlerts.alerts}
          totalAlerts={dashboardAlerts.totalAlerts}
        />

        <div className="flex-1 overflow-y-auto">
          <div className="mx-auto w-full max-w-[1680px] px-4 py-5 sm:px-6 sm:py-6 lg:px-8 lg:py-8">
            <Routes>
              {role_id === 1 && (
                <>
                  <Route path="dashboard-admin" element={<DashboardAdmin />} />
                  <Route path="contact-form" element={<ContactForm />} />

                  <Route
                    path="listing-clients"
                    element={<ListingAssociations />}
                  />

                  <Route path="prospection" element={<ProspectionPage />} />
                  <Route path="products" element={<ListingProducts />} />
                  <Route path="products-app" element={<ProductsAppPage />} />
                  <Route
                    path="echeances"
                    element={<FinanceCommitmentsPage />}
                  />
                  <Route path="subscriptions" element={<SubscriptionsPage />} />
                  <Route path="mise-a-jour" element={<UpdatesPage />} />
                  <Route path="tutorials" element={<TutorialsAdminPage />} />
                  <Route path="tutorials/:tutorialId" element={<TutorialEditorPage />} />
                  <Route path="parrainage" element={<ParrainagePage />} />
                  <Route path="tasks" element={<ListingTaches />} />
                  <Route path="suivi-clients" element={<SuiviClients />} />
                  <Route path="faq" element={<ListingFaq />} />
                  <Route path="progression" element={<ProgressPhasesList />} />
                  <Route path="carto-clients" element={<CartoClients />} />
                  <Route path="profil" element={<Profil />} />
                  <Route path="site-activity" element={<SiteActivityPage />} />

                  <Route
                    path="desinscriptions-admin"
                    element={<DesinscriptionsPage />}
                  />

                  <Route path="prospects" element={<ProspectsPage />} />
                  <Route path="visiteurs" element={<VisitorCenterPage />} />
                </>
              )}

              {(role_id === 2 || role_id === 3) && (
                <>
                  <Route path="notifications" element={<Notifications />} />

                  <Route
                    path="inscription-association"
                    element={<RegisterAssociationForm />}
                  />

                  <Route
                    path="mon-association"
                    element={<MonAssociationPage />}
                  />

                  <Route
                    path="tarifs"
                    element={<PricingPageForProspects />}
                  />

                  <Route path="subscriptions" element={<SubscriptionsPage />} />
                  <Route path="profil" element={<Profil />} />
                  <Route path="tutoriel" element={<Tutoriel />} />
                </>
              )}

              <Route
                path="*"
                element={
                  <div className="rounded-[30px] border border-slate-200 bg-white px-6 py-10 shadow-sm">
                    <div className="inline-flex rounded-full bg-sky-50 px-3 py-1 text-xs font-bold uppercase tracking-[0.14em] text-sky-700">
                      MonAppliClub
                    </div>

                    <h1 className="mt-4 text-2xl font-bold text-[#123B57]">
                      Bienvenue dans votre espace personnel
                    </h1>

                    <p className="mt-2 max-w-2xl text-slate-600">
                      Sélectionnez une rubrique dans le menu latéral pour
                      gérer vos applications, vos sites, vos clients, vos
                      prospects, vos abonnements et vos alertes.
                    </p>
                  </div>
                }
              />
            </Routes>
          </div>
        </div>
      </div>
    </main>
  );
};

export default MainContent;